import React, { useEffect, useState, useMemo } from 'react'
import { useStyles } from './MesActivitesStyle'
import Activite from '../../components/Activite/Activite'
import { useDispatch, useSelector } from 'react-redux'
import allActions from '../../redux/actions/user'
import { useSnackbar } from 'notistack'
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Paiement from '../../components/paiement/Paiement'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@mui/material/IconButton';
import PaymentIcon from '@material-ui/icons/Payment';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Skeleton from '@material-ui/lab/Skeleton'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { PaymentMultiple } from '../../components/PaymentMultiple'

const TENNIS = '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803'

export default function MesActivites() {

  const classes = useStyles()

  const [activites, setActivites] = useState([])
  const [reload, setReload] = useState(null)
  const [saisons, setSaisons] = useState([])
  const [trimestres, setTrimestres] = useState([])
  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()
  const state = useSelector(state => state)
  const userID = useSelector(state => state.user.id)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''


  const { enqueueSnackbar } = useSnackbar()

  // 0 trimestre | 1 saison
  const [renouvelementTab, setRenouvelementTab] = useState(0)

  useEffect(() => {
    async function fetchData() {
      dispatch(allActions.setLoading(true))
      try {
        const url = 'api/users/mes-activites/' + userID
        const res = await fetch(process.env.REACT_APP_API_PATH + url, {
          method: 'get',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token
          }
        })
        const jsonData = await res.json()
        setActivites(jsonData.data)
        setSaisons(jsonData.saisons)
        setTrimestres(jsonData.trimestres)

      } catch (err) {
        console.log('ERR: ' + res.err)
        enqueueSnackbar('Erreur: ' + res.err, { variant: `error` })
      }
      dispatch(allActions.setLoading(false))
    }
    if (userID !== undefined) {
      fetchData()
    }

  }, [userID, reload])


  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div className={classes.root} >
      <Card className={classes.card}>
        <h2 className={classes.title}>Mes activités</h2>
        <div className={classes.cont}>
          <Modal open={open} onClose={handleClose} >
            <Card sx={(theme) => ({
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '28px',
              bgcolor: '#E0E7EC',
              width: '100%',
              maxWidth: '850px',
              p: 4,
              '@media (max-width: 950px)': {
                maxWidth: '90vw',
                boxSizing: 'border-box',
                overflow: 'auto',
                maxHeight: '90vh',
              },
            })}>

              <div className={classes.tabs}>
                <div className={classes.tab_indicator} style={{ left: `${renouvelementTab * 50}%` }}></div>
                <Button className={renouvelementTab == 0 ? 'active' : ''} onClick={() => setRenouvelementTab(0)}>Trimestre</Button>
                <Button className={renouvelementTab == 1 ? 'active' : ''} onClick={() => setRenouvelementTab(1)}>Saison</Button>
              </div>

              {renouvelementTab == 0 && <>
                <Renouvellement periode="trimestre" activites={activites} trimestres={trimestres} saisons={saisons} setReload={setReload} setOpen={setOpen} />
              </>}
              {renouvelementTab == 1 && <>
                <Renouvellement periode="saison" activites={activites} trimestres={trimestres} saisons={saisons} setReload={setReload} setOpen={setOpen} />
              </>}

            </Card>
          </Modal>
          <Button onClick={handleOpen} variant='contained' disableElevation sx={{ borderRadius: 99, display: 'flex', marginLeft: 'auto' }} startIcon={<AutorenewIcon />}>Renouveler plusieurs activités</Button>
          {(activites.length === 0) ? (
            <div className={classes.skelets}>
              <Skeleton variant="rect" width={150} height={30} />
              <Skeleton variant="rect" height={100} />

              <Skeleton variant="rect" width={150} height={30} />
              <Skeleton variant="rect" height={100} />

              <Skeleton variant="rect" width={150} height={30} />
              <Skeleton variant="rect" height={100} />
            </div>
          ) : (
            Object.values(activites).map((a, i) => <Activite nom={a.nom} category={a.category} list={a.list} saisons={saisons} setReload={setReload} key={i} />)
          )}
          {(Object.values(activites).length === 0) && <p>Vous n'avez aucune activité</p>}
        </div>
      </Card>
    </div >
  )
}

function Renouvellement({ activites, periode, saisons, trimestres, setReload, setOpen }) {


  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [formatedActivities, setFormatedActivities] = useState(null)
  const [panier, setPanier] = useState([])
  const [selectedActivities, setSelectedActivities] = useState([])
  const [finalData, setFinalData] = useState(null)
  const [paymentStep, setPaymentStep] = useState(false)
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const [modePaiement, setModePaiement] = useState('unefois')


  const passeportCarteData = useMemo(() => {
    const dict = {}
    for (let i in panier) {
      const item = panier[i]

      const openFixe = item.openFixe
      if (item.activite.ACT_TA_ID === 1 || item.activite.ACT_ID === TENNIS) continue

      const periode = item.periode.libelle
      const licencie = item.licencie.id
      const type_centre = item.centre.CNT_TYPECNT_ID

      const key = `${periode}-${licencie}-${type_centre}-${openFixe}`


      if (dict[key] === undefined) dict[key] = [item]
      else dict[key].push(item)
    }

    let valid = false
    let licencie = undefined
    let periode = undefined
    let centre = undefined
    let activities_libelles = []

    const activites_passeport = Object.values(dict).find(item => item.length >= 3)
    if (activites_passeport) {
      valid = true
      licencie = activites_passeport[0].licencie
      activities_libelles = activites_passeport.map(item => item.activite.ACT_LIBELLE).join(', ')
      periode = activites_passeport[0].periode
      centre = activites_passeport[0].centre
    }

    return {
      valid,
      activities: activites_passeport,
      activities_libelles,
      licencie,
      periode,
      centre,
    }
  }, [panier])

  const payload = useMemo(() => {

    const listCours = (finalData?.activite || []).map(item => ({
      liID: item.licencie.id,
      liMail: state.user.mail,
      centre: item.centre.CNT_ID,
      category: item.periode.prices.TAR_CAT_ID || item.periode.prices.CAT_ID,
      typeAbo: getTypeCarteID(item),
      cours: item.crenaux?.CO_ID,
      dateDeb: item.periode.dates.DATE_DEBUT,
      dateFin: item.periode.dates.DATE_FIN,
      periode: getTypePeriodeID(item),
      activity: item.activite.ACT_ID,
      activityName: item.activite.ACT_LIBELLE,
      montant: getItemPrice(item)
    }))


    return finalData ? {
      'amount': finalData.total * 100,
      'currency': 'EUR',
      // 'ipnTargetUrl': 'https://1c6f-213-44-182-19.eu.ngrok.io/api/new-souscription/insertAll',
      'ipnTargetUrl': process.env.REACT_APP_API_PATH + 'api/new-souscription/insertAll',
      'orderId': `souscription - ${state.user.numero}`,
      'customer': {
        'email': state.user.mail,
        'reference': state.user.numero,
        'billingDetails': {
          'firstName': state.user.prenom,
          'lastName': state.user.nom,
          'phoneNumber': state.user.additionalInfos?.LICI_TEL
        },
        'shoppingCart': {
          'cartItemInfo': finalData.activite.map(item => ({
            'productLabel': `${item.activite.ACT_LIBELLE} - ${item.periode.libelle} - ${item.licencie.numero}`,
          }))
        }
      },
      'metadata': {
        'cours': JSON.stringify(listCours)
      }
    } : {}
  }, [finalData, state])


  useEffect(async () => {

    let newFormatedActivities = []

    if (passeportCarteData.valid) {

      const body = {
        licencie: passeportCarteData.licencie.id,
        periode: passeportCarteData.periode.prices.TAR_TYPEPER_ID,
        cnt_type: passeportCarteData.centre.CNT_TYPECNT_ID
      }
      let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/passeport-price/', body, dispatch)

      const carte_passeport = {
        passeport: true,
        centre: passeportCarteData.centre,
        licencie: passeportCarteData.licencie,
        price: data.TAR_MONTANT,
        periode: passeportCarteData.periode,

        // activité Pass dans la db
        activite: {
          ACT_ID: 'EFDA24CD-E6D9-4A18-8384-62E6FC446335',
          ACT_LIBELLE: 'Pass'
        }
      }

      newFormatedActivities = [carte_passeport, ...panier]
    } else {
      newFormatedActivities = panier
    }

    setFormatedActivities(newFormatedActivities)
    setFinalData({
      activite: newFormatedActivities.map(item => ({ ...item, isInPasseport: isInPasseport(item) })),
      total: getTotal(newFormatedActivities),
      passeportCarteData: passeportCarteData
    })
  }, [passeportCarteData])

  useEffect(async () => {
    const data = selectedActivities.map((activity) => ({
      centre: {
        CNT_ID: activity.CNT_ID,
        CNT_LIBELLE: activity.CNT_LIBELLE,
        CNT_TYPECNT_ID: activity.CNT_TYPECNT_ID,
      },
      activite: {
        ACT_ID: activity.ACT_ID,
        ACT_LIBELLE: activity.ACT_LIBELLE,
        ACT_TA_ID: activity.ACT_TA_ID,
        CO_AGEMAX: activity.CO_AGEMAX,
        CO_AGEMIN: activity.CO_AGEMIN,
        TYPE_ABO: activity.TYPE_ABO,
      },
      recu: {
        REC_ID: activity.REC_ID,
        REC_DATEDEBUT: activity.REC_DATEDEBUT,
        REC_DATEFIN: activity.REC_DATEFIN,
        REC_PAY_ID: activity.REC_PAY_ID,
        REC_SOU_ID: activity.REC_SOU_ID,
      },
      crenaux: {
        ACT_TA_ID: activity.ACT_TA_ID,
        CO_AGEMAX: activity.CO_AGEMAX,
        CO_AGEMIN: activity.CO_AGEMIN,
        CO_DATEDEBUT: activity.CO_DATEDEBUT,
        CO_DATEFIN: activity.CO_DATEFIN,
        CO_ID: activity.CO_ID,
        CO_HEUREFIN: activity.CO_HEUREFIN,
        CO_HEUREDEBUT: activity.CO_HEUREDEBUT,
        CO_NB_PLACE_LIBRE: activity.CO_NB_PLACE_LIBRE,
        CO_NB_PLACE_PRISES: activity.CO_NB_PLACE_PRISES,
        CO_NB_PLACE_PRISES_SITE: activity.CO_NB_PLACE_PRISES_SITE,
        CO_NB_PLACE_SITE: activity.CO_NB_PLACE_SITE,
        CO_NB_PLACE_WEB: activity.CO_NB_PLACE_WEB,
        JOUR_LIBELLE: activity.JOUR_LIBELLE,
        NIV_LIBELLE: activity.NIV_LIBELLE,
        TA_LIBELLE: activity.TA_LIBELLE,
        TYPE_ABO: [], // a faire mdr
      },
      niveau: activity.NIV_LIBELLE,
      category: [], // a faire mdr
      // openFixe: (selectedCrenaux) ? selectedCrenaux.TA_LIBELLE : 'open',
      periode: {
        dates: {
          DATE_DEBUT: activity.REC_DATEDEBUT,
          DATE_FIN: activity.REC_DATEFIN,
        },
        libelle: activity.PER_ID === 2 ? 'trimestre' : 'saison',
        price: 0,
        prices: {

        },
        types: [], // a faire mdr
      },
      licencie: {
        age: activity.LICI_AGE,
        name: `${activity.LICI_NOM} ${activity.LICI_PRENOM}`,
        id: activity.LICI_ID,
        numero: activity.LICI_NUMERO,
      }
    })
    )
    dispatch(allActions.setLoading(true))
    const p = await refreshBasketPrices(data)
    dispatch(allActions.setLoading(false))
    setPanier(p)
  }, [selectedActivities])


  function getAllSoloTrimestreActivities() {
    let list = []
    for (const activiteData of Object.values(activites)) {
      if (activiteData.nom === 'Solo') {
        list = [...list, ...activiteData.list]
      }
    }

    list = list.filter((item) => item.REC_TYPEPER_ID === 2)
    list = list.filter((item) => {
      const similars = list.filter((item2) => item2.ACT_ID === item.ACT_ID && item2.LICI_ID === item.LICI_ID)
      if (similars.length > 1) {
        if (similars.some((item2) => new Date(item2.REC_DATEDEBUT).getTime() > new Date(item.REC_DATEDEBUT).getTime())) {
          return false
        }
      }


      const trimestreIndex = trimestres.findIndex((trimestre) => {
        const dateFin = new Date(item.REC_DATEFIN).getTime()
        const dateTrimestreFin = new Date(trimestre.TRI_DATE_FIN).getTime()
        return dateFin === dateTrimestreFin
      })

      // pas de trimestre suivant
      if ((trimestreIndex + 1) > trimestres.length - 1) return false

      const saison = saisons.find((saison) => {
        const dateDebut = new Date(item.REC_DATEDEBUT).getTime()
        const dateSaisonDebut = new Date(saison.SAI_DEBUT).getTime()
        const dateSaisonFin = new Date(saison.SAI_FIN).getTime()
        return dateDebut >= dateSaisonDebut && dateDebut < dateSaisonFin
      })

      if (saison) {
        if (item.REC_DATEFIN === saison.SAI_FIN) return false
      }

      return true
    })

    return list
  }

  function getAllSoloSaisonActivities() {

    if (!state.interruptionRenouvellementSaison === false) return []

    let list = []
    for (const activiteData of Object.values(activites)) {
      if (activiteData.nom === 'Solo') {
        list = [...list, ...activiteData.list]
      }
    }

    list = list.filter((item) => item.REC_TYPEPER_ID === 3 || item.REC_TYPEPER_ID === 2)
    list = list.filter((item) => {
      const similars = list.filter((item2) => item2.ACT_ID === item.ACT_ID && item2.LICI_ID === item.LICI_ID)
      if (similars.length > 1) {
        if (similars.some((item2) => new Date(item2.REC_DATEDEBUT).getTime() > new Date(item.REC_DATEDEBUT).getTime())) {
          return false
        }
      }

      const saison = saisons.find((saison) => {
        const dateDebut = new Date(item.REC_DATEDEBUT).getTime()
        const dateSaisonDebut = new Date(saison.SAI_DEBUT).getTime()
        const dateSaisonFin = new Date(saison.SAI_FIN).getTime()
        return dateDebut >= dateSaisonDebut && dateDebut < dateSaisonFin
      })

      const nextSaison = saisons.find((s) => {
        const yearSaisonItem = new Date(saison.SAI_DEBUT).getFullYear()
        const year = new Date(s.SAI_DEBUT).getFullYear()
        return year === yearSaisonItem + 1
      })

      // pas de prochaine saison
      if (!nextSaison) return false

      const debutPreInscription = new Date(nextSaison.SAI_DEBUT_PREINSCRIPTION).getTime()
      const finPreInscription = new Date(nextSaison.SAI_FIN_PREINSCRIPTION).getTime()
      const today = new Date().getTime()

      // Pas dans la periode de pre inscription
      if (!(debutPreInscription <= today && today <= finPreInscription)) {
        return false
      }

      return true
    })

    return list
  }

  function getActivitiesByPeriode() {
    if (periode === 'trimestre') return getAllSoloTrimestreActivities()
    if (periode === 'saison') return getAllSoloSaisonActivities()
  }


  function getDateDebutNextPeriode(item) {

    if (item.periode.libelle === 'trimestre') {
      const trimestreIndex = trimestres.findIndex((trimestre) => {
        const dateFin = new Date(item.recu.REC_DATEFIN).getTime()
        const dateTrimestreFin = new Date(trimestre.TRI_DATE_FIN).getTime()
        return dateFin === dateTrimestreFin
      })

      // pas de trimestre suivant
      if ((trimestreIndex + 1) > trimestres.length - 1) return

      return new Date(trimestres[trimestreIndex + 1].TRI_DATE_DEBUT)

    }
    if (item.periode.libelle === 'saison') {
      const saison = saisons.find((saison) => {
        const dateDebut = new Date(item.recu.REC_DATEDEBUT).getTime()
        const dateSaisonDebut = new Date(saison.SAI_DEBUT).getTime()
        const dateSaisonFin = new Date(saison.SAI_FIN).getTime()
        return dateDebut >= dateSaisonDebut && dateDebut < dateSaisonFin
      })

      const nextSaison = saisons.find((s) => {
        const yearSaisonItem = new Date(saison.SAI_DEBUT).getFullYear()
        const year = new Date(s.SAI_DEBUT).getFullYear()
        return year === yearSaisonItem + 1
      })
      return new Date(nextSaison?.SAI_DEBUT)
    }

  }

  async function getPricesItem(item, basket) {

    if (basket === undefined) basket = panier

    const new_date_debut = getDateDebutNextPeriode(item)


    const body = {
      lici_id: item.licencie.id,
      cnt_id: item.centre.CNT_ID,
      activite: item.activite.ACT_ID,
      deuxieme_enfant: false,
      date_debut: new_date_debut
    }

    // Si activité tennis liberté
    if (item.activite.ACT_ID === TENNIS) {
      let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/periodes-prices', body, null, token)
      data.mois.price = data.mois.prices.TENNIS
      data.annee.price = data.annee.prices.TENNIS
      return data
    }

    // Si deuxieme enfant
    if (await isDeuxiemeEnfant(item, basket, new_date_debut.toISOString().split('T')[0])) {
      body.deuxieme_enfant = true
    }

    let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/periodes-prices', body, null, token)

    if (data.message) {
      enqueueSnackbar(data.message, { variant: `error` })
      handleToggle(item.recu)
      return
    }

    // Si solo +    
    const sameTypeActNumberTrimestre = basket.reduce((acc, curr) => {
      const { periode, licencie, centre } = curr
      return (periode.libelle === 'trimestre'
        && licencie.id === item.licencie.id
        && centre.CNT_TYPECNT_ID === item.centre.CNT_TYPECNT_ID)
        && !curr.seen
        ? acc + 1 : acc
    }, 0)
    const sameTypeActNumberSaison = basket.reduce((acc, curr) => {
      const { periode, licencie, centre } = curr
      return (periode.libelle === 'saison'
        && licencie.id === item.licencie.id
        && centre.CNT_TYPECNT_ID === item.centre.CNT_TYPECNT_ID)
        && !curr.seen
        ? acc + 1 : acc
    }, 0)

    //  solo +
    const url_count_act_trimestre = `api/new-souscription/number-same-act/${item.licencie.id}/${item.centre.CNT_TYPECNT_ID}/${data.trimestre.dates.DATE_DEBUT}/${data.trimestre.dates.DATE_FIN}`
    let { json: count_act_trimestre } = await allActions.fetchGetAPI(url_count_act_trimestre, null, token)
    const url_count_act_saison = `api/new-souscription/number-same-act/${item.licencie.id}/${item.centre.CNT_TYPECNT_ID}/${data.saison.dates.DATE_DEBUT}/${data.saison.dates.DATE_FIN}`
    let { json: count_act_saison } = await allActions.fetchGetAPI(url_count_act_saison, null, token)

    const solo_plus_trimestre = (sameTypeActNumberTrimestre + count_act_trimestre.number >= 1)
    const solo_plus_saison = (sameTypeActNumberSaison + count_act_saison.number >= 1)

    if (solo_plus_trimestre) {
      data.trimestre.price = data.trimestre.prices.TAR_ACTIVITE_SUPP1
      data.trimestre.types = ['SOLO +']
    } else {
      data.trimestre.price = data.trimestre.prices.TAR_MONTANT
      data.trimestre.types = ['SOLO']
    }

    if (solo_plus_saison) {
      data.saison.price = data.saison.prices.TAR_ACTIVITE_SUPP1
      data.saison.types = ['SOLO +']
    } else {
      data.saison.price = data.saison.prices.TAR_MONTANT
      data.saison.types = ['SOLO']
    }

    if (body.deuxieme_enfant) {
      data.trimestre.types.push('2eme enfant')
      data.saison.types.push('2eme enfant')
    }

    return data
  }

  async function isDeuxiemeEnfant(item, basket, dateDebut) {
    // front
    // check if there is an other child in the basket
    const hasFirstChild = basket.findIndex(
      (b_item) => (b_item.licencie.age < 18) && b_item.licencie.id !== item.licencie.id && !item.seen
    )
    if (item.licencie.age < 18 && hasFirstChild !== -1) return true


    // back
    const { json, err } = await allActions.fetchGetAPI(
      'api/new-souscription/isDeuxiemeEnfant/' + item.licencie.id + '/' + dateDebut,
      null,
      token
    )

    let isDeuxiemeEnfant = false

    if (err) enqueueSnackbar('Erreur: ' + err, { variant: `error` })
    else if (json.err) enqueueSnackbar('Erreur: ' + json.err, { variant: `error` })
    else isDeuxiemeEnfant = json.NEW_TARIF_REDUIT

    return isDeuxiemeEnfant

  }

  async function refreshBasketPrices(basket) {
    if (basket === undefined) basket = panier
    const newBasket = basket.map(item => ({ ...item, seen: false }))
    newBasket.reverse()

    for (let i in newBasket) {
      const filtered = [...newBasket]
      filtered.splice(i, 1)
      const data = await getPricesItem(newBasket[i], filtered)
      

      newBasket[i].seen = true
      newBasket[i].periode = {
        libelle: newBasket[i].periode.libelle,
        ...data[newBasket[i].periode.libelle]
      }
    }
    newBasket.reverse()
    return newBasket
  }

  function isInPasseport(item) {
    return passeportCarteData.activities?.includes(item)
  }

  function getTotal(formatedActivities_) {
    if (!formatedActivities_) formatedActivities_ = formatedActivities
    if (!formatedActivities_) return null
    let total = 0
    for (const item of formatedActivities_) {
      if (item.passeport) total += item.price
      else if (!isInPasseport(item)) {
        total += item.periode.price
      }
    }
    return total
  }

  function resetAll() {
    setReload(new Date())
    setFinalData(null)
    setSelectedActivities([])
    setOpen(false)
    setPaymentStep(false)
  }

  function getTypeCarteID(item) {
    // Tennis liberté
    if (item.activite.ACT_ID === '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803') return 3

    // carte passeport ou item de la carte passeport
    if (item.passeport) return 2

    // solo et solo +
    return 1
  }

  function getTypePeriodeID(item) {
    switch (item.periode.libelle) {
      case 'mois': return 1
      case 'trimestre': return 2
      case 'saison': return 3
      case 'annee': return 4
    }
  }

  function getItemPrice(item) {

    // Si c'est une carte passeport
    if (item.passeport) return item.price

    // Si c'est un item de la carte passeport
    if (item.isInPasseport) return 0

    // Si autre
    return item.periode.price
  }

  async function paymentCallback(success) {

    // Vérification que la souscription s'est bien effectué
    const body = {
      activites: panier.map(item => item.activite.ACT_ID),
      liciencies: panier.map(item => item.licencie.id)
    }
    const { json } = await allActions.fetchPostAPI('api/new-souscription/just-subscribe', body, dispatch, token)

    if ((json.data?.length ?? 0) >= panier.length) {
      enqueueSnackbar('Souscription validé', { variant: `success` })
    } else {
      let err_text = ''
      if ((json.data?.length ?? 0) == 0) err_text = 'votre souscription n\'a pas pu être enregistré.'
      else err_text = 'certaines souscriptions n\'ont pas pu être enregistrés.'
      enqueueSnackbar(`Une erreur est survenu, ${err_text}`, { variant: `error` })
    }

    if (success) resetAll()
  }

  function addPanier(activity) {

    if(periode === 'saison')
    {
      activity.REC_TYPEPER_ID = 3
      activity.PER_ID = 3
    }

    setSelectedActivities(previous => {
      return [...previous, activity]
    })
  }

  const handleToggle = (value) => () => {
    const currentIndex = selectedActivities.findIndex(c => c.REC_ID === value.REC_ID)
    const newChecked = [...selectedActivities]

    if (currentIndex === -1) {
      addPanier(value)
    } else {
      newChecked.splice(currentIndex, 1)
      setSelectedActivities(newChecked)
    }
  }

  const removeActivity = (value) => () => {
    const currentIndex = selectedActivities.findIndex(c => c.REC_ID === value)
    const newChecked = [...selectedActivities]
    newChecked.splice(currentIndex, 1)
    setSelectedActivities(newChecked)
  }


  return (<>

    <Typography sx={{ mb: 2 }}>
      Choisissez les activités solo que vous voulez renouveler
    </Typography>

    <Box sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 3,
      '@media (max-width: 800px)': {
        gridTemplateColumns: '1fr',
      },
    }}>

      {!paymentStep && (
        <Box sx={{
          borderRadius: '28px',
          bgcolor: '#E8EFF4',
          padding: 2,
        }}>
          <Typography variant="h6" >
            Activités éligibles
          </Typography>
          <List dense
            sx={{
              height: 400,
              overflow: 'auto',
              pr: 1
            }}>
            {getActivitiesByPeriode().map((activity, i) => {
              return (
                <ListItem
                  sx={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    mb: i === getActivitiesByPeriode().length - 1 ? 0 : 0.5,
                  }}
                  key={activity.REC_ID}
                  secondaryAction={
                    <Checkbox
                      edge="end"
                      checked={selectedActivities.findIndex(act => act.REC_ID === activity.REC_ID) !== -1}
                      disableRipple
                      onChange={handleToggle(activity)}
                    />
                  }
                  disablePadding
                >
                  <ListItemButton onClick={handleToggle(activity)}>
                    <Box>
                      <ListItemText primary={activity.ACT_LIBELLE} secondary={activity.LICI_NOM + " " + activity.LICI_PRENOM} />
                      <ListItemText secondary={new Date(activity.REC_DATEDEBUT).toLocaleDateString() + " - " + new Date(activity.REC_DATEFIN).toLocaleDateString()} />
                    </Box>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}

      <Box sx={{
        borderRadius: '28px',
        bgcolor: '#E8EFF4',
        padding: 2,
      }}>
        <Typography variant="h6" >
          Votre panier
        </Typography>
        {selectedActivities.length > 0 ?
          <List dense
            sx={{
              height: 400,
              overflow: 'auto',
              pr: 1
            }}>
            {(finalData?.activite || [])
              .sort((a, b) => {
                if (a.passeport) return -1
                if (b.passeport) return 1
                if (a.isInPasseport) return -1
                if (b.isInPasseport) return 1
                return 0
              })
              .map((item) => item.passeport ?
                <ListItem sx={{
                  mb: 0.5,
                  padding: '4px 48px 4px 16px'
                }}>
                  <Box>
                    <ListItemText primary={item.centre.CNT_LIBELLE + ': Carte passeport'} secondary={item.licencie.name} />
                    <ListItemText secondary={'Un ' + item.periode.libelle + ' (' + new Date(item.periode.dates.DATE_DEBUT).toLocaleDateString() + ' au ' + new Date(item.periode.dates.DATE_FIN).toLocaleDateString() + ')'} />
                    <ListItemText secondary={'Licencie: ' + item.licencie.name} />
                    <span style={{ fontSize: 20, color: 'rgb(0, 127, 255)' }}> {item.price}€</span>
                  </Box>
                </ListItem> :
                <ListItem
                  sx={{
                    mb: 0.5,
                    padding: '4px 48px 4px 16px!important',
                    position: 'relative',
                    paddingLeft: item.isInPasseport ? '40px!important' : 'unset',
                    '&:before': item.isInPasseport ? {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '20px',
                      bottom: '-4px',
                      width: 3,
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    } : {}

                  }}
                  key={item.recu.REC_ID ? item.recu.REC_ID : 'passeport'}
                  secondaryAction={!paymentStep ? <IconButton onClick={removeActivity(item.recu.REC_ID)}>
                    <DeleteIcon />
                  </IconButton> : null}
                  disablePadding
                >
                  <Box >
                    <ListItemText primary={item.activite.ACT_LIBELLE} secondary={item.licencie.name} />
                    <ListItemText secondary={new Date(item.periode.dates.DATE_DEBUT).toLocaleDateString() + " - " + new Date(item.periode.dates.DATE_FIN).toLocaleDateString()} />
                    <span style={{ fontSize: 20 }}>
                      {item.isInPasseport ? (
                        <>
                          <Box sx={{
                            position: 'relative',
                            display: 'inline-block',
                            color: '#777',
                            '&:before': {
                              content: '""',
                              position: 'absolute',
                              width: '100%',
                              height: 2,
                              backgroundColor: 'currentColor',
                              top: '30%',
                              left: '50%',
                              transform: 'rotate(-20deg) translate(-50%, -50%)'
                            }
                          }}> {item.periode.price}€</Box>
                          <span style={{ fontSize: 14 }}>(carte passeport)</span>
                        </>
                      ) : (
                        <span style={{ color: 'rgb(0, 127, 255)', }}> {item.periode.price}€</span>
                      )}
                    </span>
                  </Box>
                </ListItem>
              )}
          </List>
          : <Box sx={{ mt: 4, textAlign: 'center', color: 'rgba(0, 0, 0, 0.6)' }}>
            <SentimentVeryDissatisfiedIcon fontSize="large" />
            <Typography >
              Le panier est vide
            </Typography>
          </Box>
        }
      </Box>

      {paymentStep && (
        <Box sx={{
          borderRadius: '28px',
          bgcolor: '#E8EFF4',
          padding: 2,
        }}>
          <Typography variant="h6">
            Paiement
          </Typography>
          {finalData && periode === 'saison' && (<>

            {state.interruptionX10 === false && (
              <FormControl style={{ marginBlock: 12 }}>
                <div style={{ fontWeight: 'bold', color: 'rgb(0, 88, 178)' }}>Mode de paiement</div>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  onChange={(e) => setModePaiement(e.target.value)}
                  value={modePaiement}>
                  <FormControlLabel control={<Radio value="unefois" />} label="Payer en 1 fois" />
                  <FormControlLabel control={<Radio value="dixfois" />} label="Payer en 10 fois" />
                </RadioGroup>
              </FormControl>
            )}


            {modePaiement === 'unefois' && (
              <Paiement payload={payload} callback={paymentCallback} />
            )}
            {modePaiement === 'dixfois' && (
              <PaymentMultiple finalData={finalData} disabled={false} />
            )}

          </>)}

        </Box>
      )}

    </Box>
    <Box mt={3} sx={{ display: 'flex' }}>

      {paymentStep ? (
        <Button variant='contained' disableElevation sx={{
          borderRadius: 99,
        }}
          startIcon={<ArrowBackIcon />}
          onClick={() => setPaymentStep(false)}
        >
          Retour
        </Button>
      ) : (
        <>
          <Button variant='contained' disableElevation sx={{
            borderRadius: 99,
          }}
            onClick={() => setOpen(false)}
          >
            Quitter
          </Button>
          <Button variant='contained' disableElevation disabled={selectedActivities.length === 0} sx={{
            borderRadius: 99,
            ml: 'auto',
            display: 'flex',
          }}
            startIcon={<PaymentIcon />}
            onClick={() => setPaymentStep(true)}
          >
            Procéder au paiement
          </Button>
        </>
      )}

    </Box>
  </>)
}